module.exports = __webpack_public_path__ + "img/maestro.f56c593b.png";